import {AfterViewChecked, AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {GlOnResize, GlOnShow, GoldenLayoutContainer} from 'ngx-golden-layout';
import GoldenLayout from 'golden-layout';
import {FieldService} from '../../stores/field.service';
import {notify, Route, RouteLoader, RouteParams, RouteRenderer, Tractor} from 'shared';
import moment from 'moment';
import {TractorService} from '../../stores/tractor.service';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {animate, style, transition, trigger, state, group} from '@angular/animations';
import {Subject} from 'rxjs';

export class TractorHistoryRequest {
  minStopDuration = 60;
  isToday: boolean;
  from: Date;
  to: Date;
  tractor?: Tractor;
  currentFilter = 2;

  constructor() {
    this.from = moment().startOf('day').toDate();
    this.to = moment().endOf('day').toDate();
    this.isToday = true;
  }
}

@Component({
  selector: 'app-tractors-history',
  templateUrl: './tractors-history.component.html',
  styleUrls: ['./tractors-history.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('true', style({
        opacity: '1',
        height: '*',
        marginTop: '0.25rem',
        borderWidth: '1px 0 0 1px',
      })),
      state('false', style({
        opacity: '0',
        height: '0',
        marginTop: '0',
        borderWidth: '0',
      })),
      transition('* => *', animate('200ms ease'))
    ]),
    trigger('slideLeftInOut', [
      state('true', style({
        opacity: '1',
        width: '*',
        marginRight: '0.25rem',
        borderWidth: '0 1px 0 0',
      })),
      state('false', style({
        opacity: '0',
        width: '0',
        marginRight: '0',
        borderWidth: '0',
      })),
      transition('* => *', animate('200ms ease'))
    ]),
  ]
})
export class TractorsHistoryComponent implements OnInit, AfterViewInit, GlOnShow, GlOnResize {

  @ViewChild('mainContainer', {static: true})
  mainContainer: ElementRef;

  contentSizeChanged: Subject<number[]> = new Subject<number[]>();
  contentSizeChanged$ = this.contentSizeChanged.asObservable();
  contentSize = [0, 0];

  tractor?: Tractor;
  request = new TractorHistoryRequest();
  toolbarLoadingVisible = false;
  popupLoadingVisible = false;
  tractors: DataSource;
  selectedTab = 0;
  fuelTab = {id: 4, text: 'Carburant', disabled: true};
  tabs = [
    {id: 0, text: 'Dashbaord'},
    {id: 1, text: 'Carte'},
    {id: 2, text: 'Graph'},
    this.fuelTab,
    {id: 3, text: 'Messages'}];

  route: Route;
  routeParams: RouteParams;
  routeRenderer: RouteRenderer = new RouteRenderer();
  routeLoader: RouteLoader = new RouteLoader();
  isRouteLoading: boolean;

  constructor(
    @Inject(GoldenLayoutContainer) private container: GoldenLayout.Container,
    private tractorService: TractorService,
  ) {
    // Access state
    const cmpState = container.getState();

    // Get the tractor from the state
    this.tractor = cmpState.tractor || null;

    this.request.tractor = cmpState.tractor || null;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.toolbarLoadingVisible = true;
      // this.popupLoadingVisible = true;
    }, 50);
    this.tractorService.newDataSource({
      paginate: false,
    }).load().then(all => {
      // Data source
      this.tractors = new DataSource({
        paginate: false,
        store: new ArrayStore({
          key: 'id',
          data: all,
        }),
      });
      this.toolbarLoadingVisible = false;
      this.popupLoadingVisible = false;
    });
  }

  selectTab(e: any) {
    const itemIndex = e.itemData.id;
    // From messages to carte
    if (itemIndex === 1 || itemIndex === 3 || itemIndex === 4) {
      setTimeout(() => {
        this.updateMainContainerSize(true);
      }, 20);
    }
    this.selectedTab = itemIndex;
  }

  animationDone($event: any) {
    setTimeout(() => {
      this.updateMainContainerSize();
    }, 100);
  }

  glOnResize(): void {
    this.updateMainContainerSize();
  }

  glOnShow(): void {
  }

  private updateMainContainerSize(force?: boolean) {
    const newContentSize = [
      this.mainContainer.nativeElement.clientWidth,
      this.mainContainer.nativeElement.clientHeight
    ];
    if (force || newContentSize[0] !== this.contentSize[0] || newContentSize[1] !== this.contentSize[1]) {
      this.contentSize = newContentSize;
      this.contentSizeChanged.next(this.contentSize);
    }
  }

  load(request: TractorHistoryRequest) {
    this.isRouteLoading = true;
    this.routeParams = new RouteParams(this.request.minStopDuration);
    this.tractorService.route(this.routeLoader,
      request.tractor.id,
      request.from,
      request.to,
      this.routeParams,
    ).subscribe((r) => {
      if (r.isLoaded) {
        this.isRouteLoading = false;
        if (r.isEmpty()) {
          notify('Pas données dans l\'intervale sélectioné');
          return;
        }
        this.route = r.route;
        this.fuelTab.disabled = this.route.fuel_consumption === null;
      }
    });
  }

  export() {
    this.toolbarLoadingVisible = true;
    this.routeRenderer.export(this.filename()).then(_ => this.toolbarLoadingVisible = false);
  }

  filename(): string {
    const startDate = moment(this.request.from).format('YYYY-MM-DD-HH-mm-ss');
    const endDate = moment(this.request.to).format('YYYY-MM-DD-HH-mm-ss');
    return `historique-${this.request.tractor.name}-${startDate}-${endDate}`;
  }
}
